import React, { ChangeEvent, Dispatch, DispatchWithoutAction, FC, KeyboardEvent, useState } from 'react';

import { fc } from 'i18n';
import { plus, search as searchIcon } from 'assets/icons';
import Input from 'components/molecules/input';
import Button from 'core/react/general/form/Button';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './styles.module.css';

interface IControlsProps {
  search: string | null;
  searchHandler: Dispatch<string>;
  openModal: DispatchWithoutAction;
}

export const Controls: FC<IControlsProps> = ({ search, searchHandler, openModal }) => {
  const [searchText, setSearchText] = useState<string>(search || '');

  const onType = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const onSearch = () => {
    searchHandler(searchText);
  };

  const resetSearch = () => {
    setSearchText('');
    searchHandler('');
  };

  const handleKeyDown = ({ key }: KeyboardEvent<HTMLInputElement>) => key === 'Enter' && onSearch();

  return (
    <div className={styles.wrapper}>
      <div className={styles.search}>
        <Input
          className={styles.searchInput}
          icon={searchIcon}
          placeholder={fc('search')}
          value={searchText}
          onChange={onType}
          onKeyDown={handleKeyDown}
          reset={resetSearch}
        />
        <Button className={styles.searchButton} onClick={onSearch}>
          {fc('search')}
        </Button>
      </div>
      <Button className={`${styles.addButton} active`} onClick={openModal}>
        <SvgWrapper width={16} height={16} details={plus} color="#fff" />
        <span> {fc('create')}</span>
      </Button>
    </div>
  );
};
